import { Expose } from 'class-transformer';
import { _FirebaseDocument } from './Models';
import type { DocumentSnapshot } from 'firebase/firestore';

/** An object members can give feedback on (a topic, a question): its feedbacks
 * live under `{path}/feedbacks/{uid}`. Reading and writing them is the
 * feedbacks store's job (`readOwnFeedback`, `saveOwnFeedback`). */
export abstract class FeedbacksBase extends _FirebaseDocument {}

export class Feedback extends _FirebaseDocument {
    @Expose()
    public rate: number
    @Expose()
    public comment: string

    collection(): string {
        return "feedbacks";
    }

    static fromFirebase(o: DocumentSnapshot): Feedback | null {
        return _FirebaseDocument._fromFirebase(Feedback, o);
    }
}
